<template>
    <div class="">
         <net-pa-card :IsMinus="IsMinus" :IdElement="'SetBoard'" :IsCollapse="IsCollapse">
          <template slot="header">
            <h6 class="text-right d-inline">ثبت تابلو اعلانـــات</h6>
            <small class="text-warning font-weight-normal mr-3"> برای ثبت اعلان جدید بر روی فلاش روبه رو کلیک کنید</small>
          </template>
          <template slot="content">
            <div class="container" id="TablooElanat">
                <div class="row" v-if="$session.get('ModirShobe') && !$session.get('IsRahbar')">
                    <div class="text-center w-100 rounded p-2 bg-dark mb-3 mx-2" >
                        <span class="text-light" style="font-size:18px !important;">مدیریت شعبه : </span>
                        <span class="text-danger" style="font-size:18px !important;">{{TafsilyList.nameTafsiliType}}</span>
                        <small class="text-warning mr-4 font-weight-normal"> ( اعلانات ثبت شده توسط شما فقط و فقط برای شعبه شما قابل نمایش می باشد ) </small>
                    </div>
                </div>
                <div class="row mb-4" v-if="$session.get('IsRahbar')">
                    <div class="col-md-1 col-12 text-center font-weight-bold ">
                        <p class="mt-2">انتخاب شعبه</p>
                    </div>
                    <div class="col-md-4 col-12">
                        <treeselect
                                    name="demo"
                                    :multiple="multiple"
                                    :clearable="clearable"
                                    :searchable="searchable"
                                    :disabled="disabled"
                                    :open-on-click="openOnClick"
                                    :open-on-focus="openOnFocus"
                                    :clear-on-select="clearOnSelect"
                                    :close-on-select="closeOnSelect"
                                    :always-open="alwaysOpen"
                                    :append-to-body="appendToBody"
                                    :options="options3"
                                    v-model="value3"
                                    :normalizer="normalizer3"
                                    @select="ItemSelected3"
                                    @deselect="ItemDeselect3">
                        </treeselect>
                    </div>
                </div>
              <div class="row" >
                <div class="col-md-5 col-12">
                    <small>عنوان اعلان</small>
                    <input type="text" class="form-control required" v-model="DataAxios.SubjectTabloElanat">
                </div>
                <div class="col-md-3 col-12">
                    <small>تاریخ شروع نمایش اعلان</small>
                    <date-picker :editable="true" :auto-submit="true" color="#435ebe"
                         v-model="DataAxios.AzTarixSaat" input-class="required form-control"></date-picker>
                </div>
                <div class="col-md-3 col-12">
                    <small>تاریخ پایان نمایش اعلان</small>
                    <date-picker :editable="true" :auto-submit="true" color="#435ebe"
                        v-model="DataAxios.TaTarixSaat" input-class="required form-control"></date-picker>
                </div>
                <div class="col-md-1 col-12">
                    <small> ترتیب</small>
                    <input type="text" class="form-control " maxlength="2" dir="ltr" v-model="DataAxios.Tartib">
                </div>
                <div class="col-12">
                    <small> متن اعلان</small>
                    <textarea type="text" rows="5" class="form-control required" v-model="DataAxios.TxtMatnTabloElanat"></textarea>
                </div>
                <button class="btn btn-success NetPa-btn mt-3 mr-3" v-if="!EditMode" @click="SetBoard"><i class="fas fa-plus mx-2"></i>ثبت تابلــو اعلانات</button>
                <button class="btn btn-warning NetPa-btn mt-3 mr-3" v-if="EditMode" @click="Edit"><i class="fas fa-pen mx-2"></i>ویرایش تابلــو اعلانات</button>
                <button class="btn btn-danger NetPa-btn mt-3 mr-3" v-if="EditMode" @click="CancelEdit"><i class="fas fa-times mx-2"></i>انصراف</button>
              </div>
            </div>
          </template>
        </net-pa-card>
         <net-pa-card v-if="!EditMode">
          <template slot="header">
            <h6 class="text-right">لیست تابلو اعلانـــات </h6>
          </template>
          <template slot="content">
            <div class="container">
               <vue-bootstrap4-table v-if="$store.state.renderComponentGrid" :rows="Rows" :columns="Columns" :config="config" :classes="classes">
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <p class="text-center">{{ props.row.vbt_id }}</p>
              </template>
              <template slot="Action" slot-scope="props">
                <button type="button" title="جزئـــیات" class="btn btn-outline-orange ml-2" @click="GetDetail(props.row)" style="font-size: 14px !important" data-toggle="modal" data-target="#Modal-Orange" dir="ltr">
                    <span class="fa fa-list" tabindex="-1"></span>
                </button>
                <button type="button" title="ویرایش" class="btn btn-outline-danger ml-2" @click="OnEdit(props.row,$session.get('IsRahbar'))" style="font-size: 14px !important" dir="ltr">
                    <span class="fas fa-pen" tabindex="-1"></span>
                </button>
                <button type="button" title="حذف" class="btn btn-danger ml-2" @click="OnDelete(props.row)" style="font-size: 14px !important" dir="ltr">
                    <span class="fas fa-trash" tabindex="-1"></span>
                </button>
                <small class="" v-if="props.row.isActive==true">
                  <div class="btn Pointer btn-outline-danger" @click="Active(props.row,false)"><i class="fas fa-eye-slash ml-2"></i> غیر فعــال کردن</div>
                </small>
                <small class="" v-if="props.row.isActive==false">
                  <div class="btn Pointer btn-outline-success" @click="Active(props.row,true)"><i class="fas fa-eye ml-2"></i> فعــال کردن</div>
                </small>
              </template>
              <template slot="isActive" slot-scope="props">
                <small class="">
                  {{props.row.isActive==true?'فعال':' غیر فعال'}}
                </small>
              </template>
            </vue-bootstrap4-table>
            </div>
          </template>
        </net-pa-card>


         <modal-custom v-if="$store.state.renderComponent">
            <template v-slot:ContentModalOrange>
                <div class="row">
                <div class="col-12">
                    <vue-bootstrap4-table v-if="$store.state.renderComponent" :rows="RowsDetail" :columns="ColumnsDetail" :config="config" :classes="classes">
                        <template slot="sort-asc-icon">
                            <i class="fa fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                            <i class="fa fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                            <i class="fa fa-sort"></i>
                        </template>
                        <template slot="empty-results">
                            <p class="text-right">اطلاعاتی یافت نشد</p>
                        </template>
                        <template slot="row" slot-scope="props">
                            <p class="text-center">{{ props.row.vbt_id }}</p>
                        </template>
                        <template slot="isActive" slot-scope="props">
                            <small class="">
                                {{props.row.isActive==true?'فعال':' غیر فعال'}}
                            </small>
                        </template>
                    </vue-bootstrap4-table>
                </div>
                </div>
            </template>
        </modal-custom>
    </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import Treeselect from '@riophae/vue-treeselect'
import ModalCustom from '../Tools/ModalCustom.vue'

export default {
  components: { NetPaCard ,VueBootstrap4Table,Treeselect, ModalCustom},
    data(){
        return{
            DataAxios: {
                Id:1,
                BnpCashDbtblTabloElanatId:0,
                wwwtblTafsiliTypeId:[],
                WwwtblShobeId:0,
                TxtMatnTabloElanat:'',
                AzTarixSaat:'',
                TaTarixSaat:'',
                IsActive:true,
                ZamanInsert:'',
                WwwtblAzaNoeIds:"0",
                SubjectTabloElanat:'',
                Tartib:1,
                NamayeshInLogin:false,
                wwwtblAzaIdInsert:0
            },
            TafsilyList:[],
            Rows:[],
            RowsDetail:[],
            Columns: [
                {
                label: 'id',
                name: 'id',
                visibility: false,
                },
                {
                label: 'ردیف',
                name: 'row',
                },
                
                {
                label: 'عنوان اعلان',
                name: 'subjectTabloElanat',
                visibility: true,
                },
                {
                label: 'متن اعلان',
                name: 'txtMatnTabloElanat',
                visibility: true,
                },
                {
                label: 'تاریخ شروع نمایش',
                name: 'azTarixSaat',
                visibility: true,
                },
                {
                label: 'تاریخ پایان نمایش',
                name: 'taTarixSaat',
                visibility: true,
                },
                {
                label: 'وضعیت نمایش',
                name: 'isActive',
                visibility: true,
                },
                {
                label: 'امکانات',
                name: 'Action',
                visibility: true,
                },
                
            ],
            ColumnsDetail: [
                {
                label: 'id',
                name: 'id',
                visibility: false,
                },
                {
                label: 'ردیف',
                name: 'row',
                },
                
                {
                label: 'شعبه',
                name: 'nameTafsiliType',
                visibility: true,
                },
                {
                label: 'وضعیت نمایش',
                name: 'isActive',
                visibility: true,
                },
                
            ],
            config: {
                pagination: false,
                pagination_info: false,
                per_page_options: [10, 20, 30, 50, 100],
                show_refresh_button: false,
                show_reset_button: false,
                checkbox_rows: false,
                rows_selectable: false,
                card_title: '',
                card_mode: false,
                global_search: {
                placeholder: ' جستجو',
                visibility: true,
                case_sensitive: false,
                showClearButton: true,
                searchOnPressEnter: false,
                searchDebounceRate: 1000,
                },
            },
            classes: {
                table: 'table-bordered table-striped table-sm ',
            },
            IsCollapse:true,
            IsMinus:true,
            options3: [],
            multiple: true,
            clearable: false,
            searchable: true,
            disabled: false,
            openOnClick: true,
            openOnFocus: false,
            clearOnSelect: true,
            closeOnSelect: false,
            alwaysOpen: false,
            appendToBody: false,
            value3: [],
            normalizer3(node) {
                return {
                    id: node.id,
                    label: node.nameTafsiliType,
                }
            },
            EditMode:false
        }
    },
    methods: {
        GetTafsiliType(){
            var formdata = new FormData()
            formdata.append('custcode', this.$session.get('CustCode'))
            var DataAxios_TafsiliType2 = {
                ArryfildValue: formdata,
                Method: 'Post',
                Action: 'TafsiliType/GetAll',
                Token: '',
            }
            this.$PostFormData(DataAxios_TafsiliType2).then((data)=>{
                if (this.$session.get('IsRahbar')) {
                    
                   this.options3= data
                }
                if (this.$session.get('ModirShobe') && !this.$session.get('IsRahbar')) {
                   this.TafsilyList= data.find(x=>x.id==this.$session.get('UserInfoNetPa').wwwtblTafsiliTypeId)
                }
            })

        },
        SetBoard(){
            if (this.$ValidForm('TablooElanat')) {
                // if(this.value3.length>0){
                    this.DataAxios.wwwtblTafsiliTypeId=[]
                    if (this.$session.get('IsRahbar')) {
                        this.DataAxios.wwwtblTafsiliTypeId=this.value3
                    }
                    if(this.$session.get('ModirShobe') && !this.$session.get('IsRahbar')){
                        this.DataAxios.wwwtblTafsiliTypeId.push(this.$session.get('UserInfoNetPa').wwwtblTafsiliTypeId)
                    }
                    this.DataAxios.WwwtblShobeId=this.$session.get('UserInfoNetPa').wwwtblShobeId;
                        this.DataAxios.wwwtblAzaIdInsert=this.$session.get('UserInfoNetPa').wwwtblAzaId;
                        var DataAxios_SetTabloo = {
                            ArryfildValue: this.DataAxios,
                            Method: 'Post',
                            Action: 'TablooElanat/SetTablo',
                            Token: this.$session.get('TokenNetPa'),
                        }
                            if(this.$session.get('IsRahbar')){
                                if(this.value3.length>0){
                                    this.$PostData(DataAxios_SetTabloo).then((data) => {
                                        if (data.status=="OK") {
                                            this.$mySweetDefault(
                                                'عملیات موفق',
                                                'ثبت اعلان با موفقیت انجام شد',
                                                'success',
                                                2000
                                            );
                                            this.GetGrid();
                                            this.$store.state.renderComponentGrid=false;
                                            this.$nextTick(() => {
                                                this.$store.state.renderComponentGrid=true;
                                            })   
                                        }
                                    })
                                }
                                else{
                                    this.$mySweetDefault(
                                        'فیلد الزامی',
                                        'انتخاب حداقل یک شعبه برای ثبت تابلو اعلان الزامی می باشد',
                                        'error',
                                        3000
                                    )
                                }
                            }
                            else
                            {
                                this.$PostData(DataAxios_SetTabloo).then((data) => {
                                    if (data.status=="OK") {
                                        this.$mySweetDefault(
                                            'عملیات موفق',
                                            'ثبت اعلان با موفقیت انجام شد',
                                            'success',
                                            2000
                                        );
                                        this.GetGrid();
                                        this.$store.state.renderComponentGrid=false;
                                        this.$nextTick(() => {
                                            this.$store.state.renderComponentGrid=true;
                                        })   
                                    }
                                })
                            }
                // }
                // else
                // {
                //     this.$mySweetDefault(
                //         'فیلد الزامی',
                //         'انتخاب حداقل یک شعبه برای ثبت تابلو اعلان الزامی می باشد',
                //         'error',
                //         3000
                //     )
                // }
            }
        },
        GetGrid(){
            
             const formData = new FormData()
            formData.append('AzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
            var DataAxios_GetTabloo = {
                    ArryfildValue: formData,
                    Method: 'Post',
                    Action: 'TablooElanat/GetTabloo',
                    Token: this.$session.get('TokenNetPa'),
                }
                this.$PostFormData(DataAxios_GetTabloo).then((data)=>{
                    if(data.data.length>0){
                        this.Rows=data.data
                    for (let index = 0; index < data.data.length; index++) {
                        this.DataAxios.Tartib=index+1
                    }
                    }else{
                        this.Rows=[]
                    }
                    
                })
        },
        Active(row,Active){
            const formData = new FormData()
            formData.append('Active', Active)
            formData.append('wwwtblTabloElanatId',row.id)
            var DataAxios_Active = {
                    ArryfildValue: formData,
                    Method: 'Post',
                    Action: 'TablooElanat/IsActive',
                    Token: this.$session.get('TokenNetPa'),
                }
                this.$PostFormData(DataAxios_Active).then((data)=>{
                    if(data.status == "Ok"){
                        this.GetGrid();
                        this.$store.state.renderComponentGrid=false;
                        this.$nextTick(() => {
                            this.$store.state.renderComponentGrid=true;
                        })
                    }
                    else
                    {
                        this.$mySweetDefault('خطایی رخ داده', 
                        'در تغییر حالت اعلان خطایی رخ داده ، در صورت تکرار خطا با پشتیبانی تماس حاصل کنید',
                        'warning',
                        2000)
                    }
                })
        },
         ItemSelected3(node) {
            this.value3.push(node.id)
        },
        ItemDeselect3(node) {
           for (let index = 0; index < this.value3.length; index++) {
                if (this.value3[index] == node.id) {
                this.value3.splice(index, 1)
                }
            }
        },
        GetDetail(row){
             return new Promise((success, errorFunction)=>{
                const formData = new FormData()
                formData.append('AzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
                formData.append('wwwtblTabloElanatId',row.id)
                var DataAxios_GetTabloo = {
                        ArryfildValue: formData,
                        Method: 'Post',
                        Action: 'TablooElanat/GetDetail',
                        Token: this.$session.get('TokenNetPa'),
                    }
                    this.$PostFormData(DataAxios_GetTabloo).then((data)=>{
                        this.RowsDetail=data.data
                        // console.log(data.data);
                        success(data.data)
                    })
             })
        },
        OnEdit(row,IsRahbar){
            this.GetDetail(row).then((data)=>{
                // console.log(data);
                var Detail=[];
                data.forEach(element => {
                     Detail.push(element.wwwtblTafsiliTypeId)
                });
                
                 if(IsRahbar){
                    this.value3=Detail
                    this.DataAxios= {
                        Id:row.id,
                        BnpCashDbtblTabloElanatId:row.bnpCashDbtblTabloElanatId,
                        wwwtblTafsiliTypeId:this.value3,
                        WwwtblShobeId:row.wwwtblShobeId,
                        TxtMatnTabloElanat:row.txtMatnTabloElanat,
                        AzTarixSaat:row.azTarixSaat,
                        TaTarixSaat:row.taTarixSaat,
                        IsActive:row.isActive,
                        ZamanInsert:row.zamanInsert,
                        WwwtblAzaNoeIds:row.wwwtblAzaNoeIds,
                        SubjectTabloElanat:row.subjectTabloElanat,
                        Tartib:row.tartib,
                        NamayeshInLogin:row.namayeshInLogin,
                        wwwtblAzaIdInsert:row.wwwtblAzaIdInsert
                    }
                    this.EditMode=true
                    this.IsMinus=false
                    this.IsCollapse=false
                }
                else
                {
                    this.DataAxios= {
                        Id:row.id,
                        BnpCashDbtblTabloElanatId:row.bnpCashDbtblTabloElanatId,
                        wwwtblTafsiliTypeId:Detail,
                        WwwtblShobeId:row.wwwtblShobeId,
                        TxtMatnTabloElanat:row.txtMatnTabloElanat,
                        AzTarixSaat:row.azTarixSaat,
                        TaTarixSaat:row.taTarixSaat,
                        IsActive:row.isActive,
                        ZamanInsert:row.zamanInsert,
                        WwwtblAzaNoeIds:row.wwwtblAzaNoeIds,
                        SubjectTabloElanat:row.subjectTabloElanat,
                        Tartib:row.tartib,
                        NamayeshInLogin:row.namayeshInLogin,
                        wwwtblAzaIdInsert:row.wwwtblAzaIdInsert
                    }
                    this.EditMode=true
                    this.IsMinus=false
                    this.IsCollapse=false
                }
            });
        },
        Edit(){
            if (this.$session.get('IsRahbar')){
                this.DataAxios.wwwtblTafsiliTypeId=this.value3
            }
            var DataAxios_EditTabloo = {
                ArryfildValue: this.DataAxios,
                Method: 'Put',
                Action: 'TablooElanat/EditTabloo',
                Token: this.$session.get('TokenNetPa'),
            }
                this.$PostData(DataAxios_EditTabloo).then((data) => {
                    if (data.status=="OK") {
                            this.$mySweetDefault(
                                'عملیات موفق',
                                'ویرایش اعلان با موفقیت انجام شد',
                                'success',
                                2000
                            );
                        }
                    this.GetGrid();
                    this.CancelEdit();
                    this.$store.state.renderComponentGrid=false;
                    this.$nextTick(() => {
                        this.$store.state.renderComponentGrid=true;
                    })
                })
        },
        CancelEdit(){
            this.EditMode=false
            this.IsMinus=true
            this.IsCollapse=true
            this.value3=[]
            this.DataAxios={
                Id:1,
                BnpCashDbtblTabloElanatId:0,
                wwwtblTafsiliTypeId:[],
                WwwtblShobeId:0,
                TxtMatnTabloElanat:'',
                AzTarixSaat:'',
                TaTarixSaat:'',
                IsActive:true,
                ZamanInsert:'',
                WwwtblAzaNoeIds:"0",
                SubjectTabloElanat:'',
                Tartib:1,
                NamayeshInLogin:false,
                wwwtblAzaIdInsert:0
            }
        },
        OnDelete(row){
            this.$mySweetDefaultTost(
                'درحال حذف تابلو','لطفا منتظر بمانید ...','info',false
            )
             const formData = new FormData()
            formData.append('TablooId', row.id)
            var DataAxios_DeleteTabloo = {
                    ArryfildValue: formData,
                    Method: 'delete',
                    Action: 'TablooElanat/DeleteTabloo',
                    Token: this.$session.get('TokenNetPa'),
                }
                this.$PostFormData(DataAxios_DeleteTabloo).then((data)=>{
                    if (data.status=="OK") {
                         this.$mySweetDefault(
                                'حذف موفق','اعلان مورد نظر با موفقیت حذف شد','success',2000
                            )
                        this.GetGrid();
                        this.CancelEdit();
                        this.$store.state.renderComponentGrid=false;
                        this.$nextTick(() => {
                            this.$store.state.renderComponentGrid=true;
                        })
                    }
                    
                })
        }
    },
    mounted() {
        this.GetTafsiliType();
        this.GetGrid();
    },

}
</script>
<style >
.vue-treeselect{
    z-index: 1000 !important;
}
</style>